import styled from "styled-components";

const OrdersPageStyled = styled.div`

`;

export default OrdersPageStyled;